import React from 'react';
import { CollaboratorAvatar } from '@/features/Collaborators/Shared/CollaboratorAvatar';

interface CollaboratorInfoHeaderProps {
    photoUrl?: string | null;
    name: string | null;
    email: string | null;
    backgroundColor?: string;
}

const CollaboratorInfoHeader: React.FC<CollaboratorInfoHeaderProps> = ({
    photoUrl,
    name,
    email,
    backgroundColor = 'bg-indigo-50'
}) => {
    const isTransparent = backgroundColor === 'bg-transparent';

    return (
        <div className={`flex items-center space-x-3 sm:space-x-4 ${isTransparent
            ? ''
            : `p-3 sm:p-4 ${backgroundColor} shadow sm:rounded-t-lg`
            }`}>
            <div className="sm:hidden">
                <CollaboratorAvatar photoUrl={photoUrl} name={name || ''} size="medium" />
            </div>
            <div className="hidden sm:block">
                <CollaboratorAvatar photoUrl={photoUrl} name={name || ''} size="large" />
            </div>
            <div className="flex-grow min-w-0">
                <h3 className="text-base sm:text-lg font-semibold leading-6 text-gray-900 truncate">{name}</h3>
                <p className="mt-1 text-sm text-gray-500 truncate">{email}</p>
            </div>
        </div>
    );
};

export default CollaboratorInfoHeader; 